export class TestScreenModel {
    test: string | null = null;
    ttt: string | null = null;
    noPath: string | null = null;
}
